'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenSearchService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('isomorphic-fetch');

var _description = require('./description');

var _paginator = require('./paginator');

var _search2 = require('./search');

var _formats = require('./formats/');

var _utils = require('./utils');

var _config3 = require('./config');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class to perform searches.
 */
var OpenSearchService = exports.OpenSearchService = function () {
  /**
   * Create an OpenSearchDescription object
   * @param {OpenSearchDescription} descriptionDocument The parsed description document
   */
  function OpenSearchService(descriptionDocument) {
    _classCallCheck(this, OpenSearchService);

    this.descriptionDocument = descriptionDocument;
  }

  /**
   * Get the underlying {@link OpenSearchDescription} object.
   * @returns {OpenSearchDescription}
   */


  _createClass(OpenSearchService, [{
    key: 'getDescription',
    value: function getDescription() {
      return this.descriptionDocument;
    }

    /**
     * Get the URL for the given parameters.
     * @param {object} parameters An object mapping the name or type to the value
     * @param {string} [type=null] The preferred transfer type.
     * @param {string} [method=null] The preferred HTTP method type.
     * @returns {OpenSearchUrl} The resulting URL objec.
     */

  }, {
    key: 'getUrl',
    value: function getUrl(parameters, type, method) {
      var url = this.descriptionDocument.getUrl(parameters, type, method);
      if (!url) {
        // try to give better feedback, when just one URL is possible
        var alternativeUrls = this.descriptionDocument.getUrls(null, type, method);
        if (alternativeUrls.length === 1) {
          var missingParamNames = alternativeUrls[0].getMissingMandatoryParameters(parameters).map(function (p) {
            return '"' + p.type + '"';
          });
          var unsupportedParameterKeys = alternativeUrls[0].getUnsupportedParameterKeys(parameters).map(function (k) {
            return '"' + k + '"';
          });

          var terms = [];
          if (missingParamNames.length) {
            terms.push('missing parameters: ' + missingParamNames.join(', '));
          }
          if (unsupportedParameterKeys.length) {
            terms.push('unsupported parameters keys: ' + unsupportedParameterKeys.join(', '));
          }
          throw new Error('No matching URL found, ' + terms.join(' and '));
        }

        // standard error, when multiple/no URLs with that type/method are specified
        throw new Error('No URL found for type \'' + type + '\' and the given parameters.');
      }
      return url;
    }

    /**
     * Returns a base request object for the given parameters. This allows to
     * inspect the request values before sending them to the server.
     * @param {object} parameters An object mapping the name or type to the value
     * @param {string} [type=null] The preferred transfer type.
     * @param {string} [method=null] The preferred HTTP method type.
     * @returns {object} The search request
     */

  }, {
    key: 'createSearchRequest',
    value: function createSearchRequest(parameters) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var url = null;
      if (!type) {
        // try to find a suitable URL
        var supportedTypes = (0, _formats.getSupportedTypes)();
        for (var i = 0; i < supportedTypes.length; ++i) {
          url = this.descriptionDocument.getUrl(parameters, supportedTypes[i], method);
          if (url && url.isCompatible(parameters)) {
            break;
          }
        }
        if (!url) {
          throw new Error('No compatible URL found.');
        }
      } else {
        url = this.getUrl(parameters, type, method);
      }

      return (0, _search2.createBaseRequest)(url, parameters);
    }

    /**
     * Checks whether this URL is compatible with the given parameters
     * @param {object} parameters An object mapping the name or type to the value
     * @param {string} [options.type=null] The preferred transfer type.
     * @param {string} [options.method=null] The preferred HTTP method type.
     * @param {boolean} [options.raw=false] Whether the response shall be parsed or returned raw.
     * @param {number} [options.maxUrlLength=undefined] The maximum URL length. URLs longer than that
     *                                                  will result in errors.
     * @param {boolean} [options.dropEmptyParameters=false] Whether unused parameter keys shall
     *                                                      be dropped from the request.
     * @param {object} [options.parseOptions=undefined] Additional options for the format.
     * @param {object} [options.headers=undefined] Specific headers to send to the service.
     * @returns {Promise<array>|Promise<Response>} The search result as a Promise
     */

  }, {
    key: 'search',
    value: function search(parameters) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$type = options.type,
          type = _options$type === undefined ? null : _options$type,
          _options$method = options.method,
          method = _options$method === undefined ? null : _options$method;

      var url = null;
      if (!type) {
        // try to find a suitable URL
        var supportedTypes = (0, _formats.getSupportedTypes)();
        for (var i = 0; i < supportedTypes.length; ++i) {
          url = this.descriptionDocument.getUrl(parameters, supportedTypes[i], method);
          if (url && url.isCompatible(parameters)) {
            break;
          }
        }
        if (!url) {
          throw new Error('No compatible URL found.');
        }
      } else {
        url = this.getUrl(parameters, type, method);
      }

      return (0, _search2.search)(url, parameters, options);
    }

    /**
     * Gets the suggestions for the current search parameters.
     * @param {object} parameters An object mapping the name or type to the value
     * @param {string} [method=null] The preferred HTTP method type.
     * @param {number} [maxUrlLength=undefined] The maximum URL length. URLs longer than that
     *                                          will result in errors.
     * @returns {Promise<Suggestion[]>} The fetched suggestions.
     */

  }, {
    key: 'getSuggestions',
    value: function getSuggestions(parameters) {
      var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var maxUrlLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      var type = 'application/x-suggestions+json';
      var url = void 0;
      try {
        url = this.getUrl(parameters, type, method);
      } catch (error) {
        var _config = (0, _config3.config)(),
            _Promise = _config.Promise;

        return _Promise.reject(new Error('No suggestion URL found.'));
      }
      return (0, _search2.search)(url, parameters, type, false, maxUrlLength);
    }

    /**
     * Creates a new Paginator object to enable a simpler search result handling
     * for multi-page results.
     * @param {object} parameters An object mapping the name or type to the value
     * @param {object} [options={}] Additional options for the paginator
     * @param {string} [options.type=null] The preferred transfer type.
     * @param {string} [options.method=null] The preferred HTTP method type.
     * @returns {OpenSearchPaginator} The created Paginator object.
     */

  }, {
    key: 'getPaginator',
    value: function getPaginator(parameters) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$type2 = options.type,
          type = _options$type2 === undefined ? null : _options$type2,
          _options$method2 = options.method,
          method = _options$method2 === undefined ? null : _options$method2;

      return new _paginator.OpenSearchPaginator(this.getUrl(parameters, type, method), parameters, options);
    }

    /**
     * Accesses an OpenSearch service and discovers it.
     * @param {object} url The URL to find the OpenSearchDescription XML document
     * @returns {Promise<OpenSearchService>} The {@link OpenSearchService} as a Promise
     */

  }, {
    key: 'serialize',


    /**
     * Serialize the service to a simple object.
     * @returns {object} The serialized service description
     */
    value: function serialize() {
      return {
        description: this.descriptionDocument.serialize()
      };
    }

    /**
     * Deserialize an OpenSearch description from an object.
     * @param {object} values The serialized service description
     * @returns {OpenSearchService} The deserialized service
     */

  }], [{
    key: 'discover',
    value: function discover(url) {
      var _config2 = (0, _config3.config)(),
          useXHR = _config2.useXHR,
          Promise = _config2.Promise;

      if (useXHR) {
        return new Promise(function (resolve, reject, onCancel) {
          var xhr = (0, _utils.createXHR)(url);
          xhr.onload = function () {
            try {
              resolve(OpenSearchService.fromXml(xhr.responseText));
            } catch (error) {
              reject(error);
            }
          };
          xhr.onerror = function () {
            reject(new TypeError('Failed to fetch'));
          };
          if (onCancel && typeof onCancel === 'function') {
            onCancel(function () {
              xhr.abort();
            });
          }
        });
      }
      return (0, _utils.fetchAndCheck)(url).then(function (response) {
        return response.text();
      }).then(function (response) {
        return OpenSearchService.fromXml(response);
      });
    }

    /**
     * Create a new {@link OpenSearchService} from an OSDD XML string.
     * @param {string} xml The XML string to parse the description from
     * @returns {OpenSearchService} The created service object
     */

  }, {
    key: 'fromXml',
    value: function fromXml(xml) {
      return new OpenSearchService(_description.OpenSearchDescription.fromXml(xml));
    }
  }, {
    key: 'deserialize',
    value: function deserialize(values) {
      return new OpenSearchService(_description.OpenSearchDescription.deserialize(values.description));
    }
  }]);

  return OpenSearchService;
}();


// WEBPACK FOOTER //
// /~/opensearch-browser/dist/service.js